export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (isEnabled, products) {
      pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E\u003C\u002Fdiv\u003E\u003Cp\u003EProducts which\n\u003Cstrong\u003Edo not have\u003C\u002Fstrong\u003E\na custom text field \"Pick up or delivery date\" are sent to the new checkout.\u003C\u002Fp\u003E\u003Cp\u003EProducts which do have a custom text field \"Pick up or delivery date\" are sent to the old checkout.\u003C\u002Fp\u003E\u003Cp\u003EIf a user has a mixed cart with different products, the new checkout is used if\n\u003Cstrong\u003Eany\u003C\u002Fstrong\u003E\nproducts in the cart are missing the \"Pick up or delivery date\" custom field.\u003C\u002Fp\u003E";
if (products) {
pug_html = pug_html + "\u003Ctable class=\"new-checkout-products\"\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Cth\u003EProduct\u003C\u002Fth\u003E\u003Cth\u003EEnabled\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003Ctbody\u003E\u003C\u002Ftbody\u003E";
// iterate products
;(function(){
  var $$obj = products;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var product = $$obj[pug_index0];
pug_html = pug_html + "\u003Ctr" + (pug_attr("class", pug_classes(["product",{enabled: isEnabled(product), disabled: ! isEnabled(product)}], [false,true]), false, true)) + "\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
if ((isEnabled(product))) {
pug_html = pug_html + "\u003Cspan\u003ENew checkout\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003EOld checkout\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var product = $$obj[pug_index0];
pug_html = pug_html + "\u003Ctr" + (pug_attr("class", pug_classes(["product",{enabled: isEnabled(product), disabled: ! isEnabled(product)}], [false,true]), false, true)) + "\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
if ((isEnabled(product))) {
pug_html = pug_html + "\u003Cspan\u003ENew checkout\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan\u003EOld checkout\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fthead\u003E\u003C\u002Ftable\u003E";
}
else {
pug_html = pug_html + "Loading products...";
}
    }.call(this, "isEnabled" in locals_for_with ?
        locals_for_with.isEnabled :
        typeof isEnabled !== 'undefined' ? isEnabled : undefined, "products" in locals_for_with ?
        locals_for_with.products :
        typeof products !== 'undefined' ? products : undefined));
    ;;return pug_html;}